export default __webpack_public_path__ + "static/media/violation-icons.82fc7538.png";